import React from 'react';
import { DateFormater } from "../services/DateFormater";

export function DocumentInfo(props) {
    const { formatDate } = DateFormater();

    return <>
        <h4 style={{ paddingLeft: "20px" }} className="phraseSubHeader" >{props.localizations.DocumentInfo}</h4>
        {props.documentColumns.map((column, idx) => {
            let displayValue = props.selectedDoc[column.field];
            if (props.selectedDoc[column.field] && typeof props.selectedDoc[column.field].getMonth === 'function')
                displayValue = formatDate(props.selectedDoc[column.field]);
            if (column.field.toLowerCase().indexOf("tag") > -1)
                displayValue = props.selectedDoc.documentTagsTextDisplay;

            if (column.show && !column.noFilterOrSort)
                return (
                    <span key={idx + "docInfo"} >
                        <h4 style={{ paddingLeft: "40px" }} className="phraseValueHeader">{column.Title}: </h4>
                        <div style={{ display: "inline-block", width: "50%", verticalAlign: "text-top", whiteSpace: "pre-line" }} dangerouslySetInnerHTML={{ __html: displayValue }}></div>
                    </span>
                );
            return "";
        })}
    </>;
}